// File: garage-modal.js
// Version: 3.1

(function() {
  // Helper: convert a sanitized key like "FLHR_Road_King" into "FLHR Road King"
  function displayLabelFromKey(key) {
    return key.replace(/_/g, " ");
  }

  // Helper: sanitize a string so that:
  //  • spaces become underscores (_)
  //  • hyphens (–) are preserved
  //  • all other non-alphanumeric characters are removed
  function sanitizePart(str) {
    return str
      .replace(/\s+/g, "_")           // spaces → underscore
      .replace(/[^A-Za-z0-9_-]/g, ""); // strip everything else
  }

  // Helper: shorthand for document.getElementById
  function $(id) {
    return document.getElementById(id);
  }

  // Cache DOM elements
  const openBtn      = $("open-garage");
  const closeBtn     = $("close-garage");
  const modalOverlay = $("garage-modal");
  const yearSelect   = $("garage-year");
  const makeSelect   = $("garage-make");
  const modelSelect  = $("garage-model");
  const saveBtn      = $("save-vehicle");
  const savedList    = $("saved-vehicles");

  let ymmData = {};

  // 1) Fetch ymm.json
  fetch("https://cdn.shopify.com/s/files/1/0004/3312/7455/files/ymm.json?v=1748881008")
    .then(res => res.json())
    .then(json => {
      ymmData = json;
      populateYearDropdown();
      loadSavedVehicles();
    })
    .catch(err => {
      console.error("Failed to load ymm.json:", err);
      openBtn.disabled = true;
    });

  // 2) Build Year dropdown
  function populateYearDropdown() {
    const years = Object.keys(ymmData).sort((a, b) => parseInt(b) - parseInt(a));
    yearSelect.innerHTML = '<option value="">Select Year</option>';
    years.forEach(year => {
      const opt = document.createElement("option");
      opt.value = year;
      opt.textContent = year;
      yearSelect.appendChild(opt);
    });
    yearSelect.disabled = false;
  }

  // 3) Year → Make
  yearSelect.addEventListener("change", () => {
    const y = yearSelect.value;
    makeSelect.innerHTML = '<option value="">Select Make</option>';
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    modelSelect.disabled = true;
    saveBtn.style.display = "none";
    if (!y) return makeSelect.disabled = true;
    Object.keys(ymmData[y] || {}).sort().forEach(makeKey => {
      const opt = document.createElement("option");
      opt.value = makeKey;
      opt.textContent = makeKey;
      makeSelect.appendChild(opt);
    });
    makeSelect.disabled = false;
  });

  // 4) Make → Model
  makeSelect.addEventListener("change", () => {
    const y = yearSelect.value, m = makeSelect.value;
    modelSelect.innerHTML = '<option value="">Select Model</option>';
    saveBtn.style.display = "none";
    if (!y || !m) return modelSelect.disabled = true;
    (ymmData[y][m] || []).slice().sort((a, b) =>
      displayLabelFromKey(a).localeCompare(displayLabelFromKey(b))
    ).forEach(modelKey => {
      const opt = document.createElement("option");
      opt.value = modelKey;
      opt.textContent = displayLabelFromKey(modelKey);
      modelSelect.appendChild(opt);
    });
    modelSelect.disabled = false;
  });

  // 5) Model → Show Save
  modelSelect.addEventListener("change", () => {
    saveBtn.style.display = (yearSelect.value && makeSelect.value && modelSelect.value)
      ? "inline-block"
      : "none";
  });

  // 6) Open/close modal
  openBtn .addEventListener("click",  () => modalOverlay.style.display = "block");
  closeBtn.addEventListener("click", () => modalOverlay.style.display = "none");

  // 7) Save Vehicle → persist & reload with new filter
  saveBtn.addEventListener("click", () => {
    const comboKey = [
      sanitizePart(yearSelect.value),
      sanitizePart(makeSelect.value),
      sanitizePart(modelSelect.value)
    ].join("_");

    // update localStorage + banner
    let garage = JSON.parse(localStorage.getItem("myGarage") || "[]");
    if (!garage.includes(comboKey)) {
      garage.push(comboKey);
      localStorage.setItem("myGarage", JSON.stringify(garage));
    }
    updateSavedList();
    window.showActiveBanner(comboKey);

    // close modal + reload with the proper Search & Discovery param
    modalOverlay.style.display = "none";
    const FILTER = "filter.p.m.custom.vehicle_fitment_combos";
    const url = new URL(window.location.href);
    url.searchParams.set(FILTER, comboKey);
    window.location.replace(url.toString());
  });

  // 8) Remove a saved vehicle
  function removeVehicle(key) {
    let garage = JSON.parse(localStorage.getItem("myGarage") || "[]")
      .filter(v => v !== key);
    localStorage.setItem("myGarage", JSON.stringify(garage));
    updateSavedList();
    if (localStorage.getItem("activeVehicle") === key) {
      localStorage.removeItem("activeVehicle");
      $("active-vehicle-banner").style.display = "none";
    }
  }

  // 9) Build “Saved Vehicles” list
  function updateSavedList() {
    savedList.innerHTML = "";
    JSON.parse(localStorage.getItem("myGarage") || "[]").forEach(key => {
      const li = document.createElement("li");
      li.style.marginBottom = "0.5em";

      const display = displayLabelFromKey(key);
      const selectBtn = document.createElement("button");
      selectBtn.textContent = display;
      selectBtn.style.cssText = "background:none;border:none;color:blue;text-decoration:underline;cursor:pointer";
      selectBtn.addEventListener("click", () => {
        window.showActiveBanner(key);
        modalOverlay.style.display = "none";
        // reload with the selected filter again
        const FILTER = "filter.p.m.custom.vehicle_fitment_combos";
        const u = new URL(window.location.href);
        u.searchParams.set(FILTER, key);
        window.location.replace(u.toString());
      });

      const delBtn = document.createElement("button");
      delBtn.textContent = "✕";
      delBtn.style.cssText = "margin-left:0.5em;background:none;border:none;color:red;cursor:pointer";
      delBtn.addEventListener("click", () => removeVehicle(key));

      li.appendChild(selectBtn);
      li.appendChild(delBtn);
      savedList.appendChild(li);
    });
  }

  // 10) On load → rehydrate list + banner
  function loadSavedVehicles() {
    updateSavedList();
    const active = localStorage.getItem("activeVehicle");
    if (active) window.showActiveBanner(active);
  }

  // 11) Close modal on outside click
  modalOverlay.addEventListener("click", e => {
    if (e.target === modalOverlay) modalOverlay.style.display = "none";
  });

  // 12) Disable until data arrives
  yearSelect.disabled = makeSelect.disabled = modelSelect.disabled = true;
  saveBtn.style.display = "none";
})();